/* eslint-disable prefer-destructuring */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { isMobile, isBrowser } from 'react-device-detect';
import { Row, Col } from 'reactstrap';
import Pagination, { PaginationNavigation } from '../common/Pagination';
import GalleryItem from './GalleryItem';
import ModalVideo from './ModalVideo';

const renderShowsTotal = (start, to, total) => (
  <span className="videoCount">
    { `${total} video${total > 1 ? 's' : ''}` }
  </span>
);


class GalleryIndex extends Component {
  constructor(props) {
    super(props);

    let initialData = {};
    let filterDisplayed = false;
    let atLeastOneFilterApplied = false;
    if (props.staticContext !== undefined && props.staticContext.initialData) {
      initialData = { ...props.staticContext.initialData };
      filterDisplayed = initialData.filterDisplayed;
      atLeastOneFilterApplied = initialData.atLeastOneFilterApplied;
    } else {
      initialData = { ...window.INITIAL_STATE.initialData };
      atLeastOneFilterApplied = initialData.atLeastOneFilterApplied;
      delete window.INITIAL_STATE;
      // check if we have to display the filter
      filterDisplayed = window.location.search.indexOf('filterDisplayed') > -1;
    }
    const createdAtSortDirection = initialData.sortByCreatedAt;

    this.state = {
      gallery: initialData.gallery,
      projectId: initialData.projectId,
      passwordProtected: initialData.passwordProtected,
      error: initialData.error !== undefined ? initialData.error : null,
      formFields: initialData.formFields,
      showPlayer: false,
      createdAtSortDirection,
      filterDisplayed,
      atLeastOneFilterApplied,
      startDate: initialData.startDate,
      endDate: initialData.endDate,
    };

    this.onPageChange = this.onPageChange.bind(this);
    this.onSortChange = this.onSortChange.bind(this);
    this.onPageSizeChange = this.onPageSizeChange.bind(this);
    this.onVideoPlay = this.onVideoPlay.bind(this);
    this.changeLocation = this.changeLocation.bind(this);
    this.hidePlayer = this.hidePlayer.bind(this);
    this.extractDataFiltersAndSortFromUrl = this.extractDataFiltersAndSortFromUrl.bind(this);
    this.onFilterApplied = this.onFilterApplied.bind(this);
    this.onDatesSelect = this.onDatesSelect.bind(this);
  }


  onPageChange(newPage) {
    const updatedGallery = { ...this.state.gallery, page: newPage };
    this.setState({ gallery: updatedGallery });
    this.changeLocation(newPage);
  }

  onSortChange(sortBy, direction) {
    if (direction === 'desc') {
      sortBy = `-${sortBy}`;
    }
    // check if we have data-filers or sort params on the query
    const dataFiltersAndSort = this.extractDataFiltersAndSortFromUrl();

    const { otherParams, dataFilters } = dataFiltersAndSort;

    let newLocation = `${otherParams.length ? `${otherParams}&` : ''}` +
      `sort=${sortBy}` +
      `${dataFilters.length ? `&${dataFilters}` : ''}`;

    if (this.state.filterDisplayed && newLocation.indexOf('filterDisplayed') === -1) {
      newLocation = `${newLocation}&filterDisplayed=true`;
    }

    window.location.search = newLocation;
  }

  onPageSizeChange(newSize) {
    let newPage = this.state.gallery.page;
    if (this.state.gallery.page !== 1) {
      let previousPageLastItemCount = this.state.gallery.limit * this.state.gallery.page;
      if (previousPageLastItemCount > this.state.gallery.total) {
        previousPageLastItemCount = this.state.gallery.total;
      }
      newPage = Math.ceil(previousPageLastItemCount / newSize);
      if (newPage < 1) {
        newPage = 1;
      }
    }

    this.changeLocation(newPage, newSize);
  }


  onVideoPlay(videoUrl, raw) {
    if (isMobile) {
      window.open(videoUrl, '_blank');
    } else {
      const ratio = `${raw.width}:${raw.height}`;
      this.setState({ showPlayer: true, videoUrl, ratio });
    }
  }

  onFilterApplied() {
    this.setState({ atLeastOneFilterApplied: true });
  }

  onDatesSelect({ startDate, endDate }) {
    this.setState({ startDate, endDate }, this.changeLocation);
  }

  /**
   * This is executed when changing the page or the page size, it outputs the location.search property
   */
  changeLocation(newPage = null, newLimit = null) {
    const page = newPage === null ? this.state.gallery.page : newPage;
    const limit = newLimit === null ? this.state.gallery.limit : newLimit;
    let newLocation = `?page=${page}&limit=${limit}`;

    const { filterDisplayed, startDate, endDate } = this.state;

    // check if we have data-filers or sort params on the query
    const dataFiltersAndSort = this.extractDataFiltersAndSortFromUrl();
    if (dataFiltersAndSort.sort) {
      newLocation = `${newLocation}&sort=${dataFiltersAndSort.sort}`;
    }
    if (dataFiltersAndSort.dataFilters.length) {
      newLocation = `${newLocation}&${dataFiltersAndSort.dataFilters}`;
    }

    if (filterDisplayed && newLocation.indexOf('filterDisplayed') === -1) {
      newLocation = `${newLocation}&filterDisplayed=true`;
    }

    if (startDate || endDate) {
      newLocation = `${newLocation}&startDate=${startDate}&endDate=${endDate}`;
    }

    window.location.search = newLocation;
  }

  hidePlayer() {
    this.setState({ showPlayer: false });
  }

  /**
   * This method analyzes url's search params and extracts the sort and data-xxx params
   * Then returns an object with sort and dataFilters properties
   */
  extractDataFiltersAndSortFromUrl() {
    let sortParam = null;
    const otherParams = [];
    const dataFilters = _.chain(window.location.search)
      .replace('?', '')
      .split('&')
      .map(_.ary(_.partial(_.split, _, '='), 1))
      .value()
      .filter(([key, value]) => {
        if (key.startsWith('data-')) {
          return true;
        } else if (key === 'sort') {
          sortParam = value;
        } else if (key === 'filterDisplayed' && this.state.filterDisplayed) {
          // keep the filterDisplayed in url only if the filter wasn't manually closed
          otherParams.push(`${key}=${value}`);
        } else {
          otherParams.push(`${key}=${value}`);
        }
        return false;
      })
      .map(([key, value]) => `${key}=${value}`);

    return {
      sort: sortParam,
      dataFilters: dataFilters.join('&'),
      otherParams: otherParams.join('&'),
    };
  }

  renderGalleryItems() {
    if (this.state.gallery.total === 0) {
      return (
        <span>
          <h3>There are no videos matching those filters and date range</h3>
        </span>
      );
    } else if (this.state.error) {
      return (
        <div className="error-info-container">
          <h3>Server error</h3>
          <p>{ this.state.error.details }</p>
        </div>
      );
    }
    return (
      <div className="row videoGalleryContainer">
        {
          this.state.gallery.data.length ?
            this.state.gallery.data.map(galleryItem =>
              (<GalleryItem
                key={galleryItem.id}
                projectId={this.state.projectId}
                passwordProtected={this.state.passwordProtected}
                videoInfo={galleryItem}
                onVideoPlay={this.onVideoPlay}
              />))
            :
            <span />
        }
      </div>
    );
  }

  render() {
    if (this.state.gallery === undefined) {
      return (
        <div>
          <div className="row">
            <div className="col">
              <div className="error-info-container">
                <h3>Server error</h3>
                <p>{ this.state.error.details }</p>
              </div>
            </div>
          </div>
        </div>
      );
    }

    const sortDirection = this.state.createdAtSortDirection;
    const sortLabel = `${(sortDirection === 'desc' ? 'Newest' : 'Oldest')} First`;
    const { startDate, endDate } = this.state;
    return (
      <Row id="gallery-page">
        <Col xs={12} id="gallery-page-main-container">
          {
            !this.state.error &&
              <Pagination
                currentPage={this.state.gallery.page}
                totalItems={this.state.gallery.total}
                pageLimit={this.state.gallery.limit}
                totalPages={this.state.gallery.pages}
                paginationShowsTotal={renderShowsTotal}
                onPageChange={this.onPageChange}
                onPageSizeChange={this.onPageSizeChange}
                sortingOptions={[{
                  sortBy: 'createdAt',
                  label: sortLabel,
                  direction: sortDirection,
                }]}
                onSortChange={this.onSortChange}
                formFields={this.state.formFields}
                filterDisplayed={this.state.filterDisplayed}
                onFilterButtonClick={() => {
                  this.setState({ filterDisplayed: !this.state.filterDisplayed });
                }}
                onFilterApplied={this.onFilterApplied}
                atLeastOneFilterApplied={this.state.atLeastOneFilterApplied}
                dateRange={{ startDate, endDate }}
                onDatesSelect={this.onDatesSelect}
              />
          }
          { this.renderGalleryItems() }
        </Col>
        {
          !this.state.error &&
            <Row>
              <Col xs={{ offset: 8, size: 4 }} align="right">
                <PaginationNavigation
                  currentPage={this.state.gallery.page}
                  totalPages={this.state.gallery.pages}
                  onPageChange={this.onPageChange}
                />
              </Col>
            </Row>
        }
        { isBrowser &&
        <ModalVideo
          isOpen={this.state.showPlayer}
          onClose={this.hidePlayer}
          videoUrl={this.state.videoUrl}
          ratio={this.state.ratio}
        />
        }
      </Row>
    );
  }
}

GalleryIndex.propTypes = {
  staticContext: PropTypes.object,
};

GalleryIndex.defaultProps = {
  staticContext: {},
};

export default GalleryIndex;



// WEBPACK FOOTER //
// ./src/client/components/gallery/index.js